import { render, staticRenderFns } from "./CampaignOverviewChart.vue?vue&type=template&id=10edcbe2"
import script from "./CampaignOverviewChart.vue?vue&type=script&lang=js"
export * from "./CampaignOverviewChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports